import type { RouteRecordRaw } from 'vue-router';

export const schoolsRoutes: RouteRecordRaw = {
    path: 'schools',
    components: {
        default: () => import('@/layouts/modules/schools/SchoolsLayout.vue'),
        sidebar: () => import('@/layouts/modules/schools/SchoolAside.vue')
    },
    children: [
        {
            path: '',
            name: 'schools',
            component: () => import('@/views/modules/school/schools/SchoolListView.vue'),
        },
        {
            path: 'users',
            name: 'schoolUsers',
            component: () => import('@/views/modules/school/users/SchoolUsersListView.vue'),
            children: [
                {
                    path: ':userId/update',
                    name: 'createSchoolUser',
                    component: () => import('@/views/modules/school/users/ConnectUsersToSchoolModal.vue'),
                }
            ],
        },
        {
            path: 'create',
            name: 'newSchool',
            component: () => import('@/views/modules/school/schools/CreateSchoolView.vue'),
        },
        {
            path: ':schoolId/update',
            name: 'updateSchool',
            component: () => import('@/views/modules/school/schools/UpdateSchoolView.vue'),
            props: true,
        },
        {
            path: ':schoolId',
            props: true,
            children: [
                {
                    path: 'staffs',
                    name: 'staff',
                    component: () => import('@/views/modules/school/profiles/staff/StaffListView.vue'),
                    props: true,
                },
                {
                    path: 'staffs/new',
                    name: 'newStaff',
                    component: () => import('@/views/modules/school/profiles/staff/StaffCreateView.vue'),
                    props: true,
                },
                {
                    path: 'staffs/:staffId/update',
                    name: 'updateStaff',
                    component: () => import('@/views/modules/school/profiles/staff/StaffUpdateView.vue'),
                    props: true,
                },
                {
                    path: 'parents',
                    name: 'parents',
                    component: () => import('@/views/modules/school/profiles/parents/ParentListView.vue'),
                    props: true,
                },
                {
                    path: 'parents/new',
                    name: 'newParent',
                    component: () => import('@/views/modules/school/profiles/parents/ParentCreateView.vue'),
                    props: true,
                },
                {
                    path: 'parents/:parentId/update',
                    name: 'updateParent',
                    component: () => import('@/views/modules/school/profiles/parents/ParentUpdateView.vue'),
                    props: true,
                },
                {
                    path: 'students',
                    name: 'students',
                    component: () => import('@/views/modules/school/profiles/student/StudentListView.vue'),
                    props: true,
                },
                {
                    path: 'students/new',
                    name: 'newStudent',
                    component: () => import('@/views/modules/school/profiles/student/StudentCreateView.vue'),
                    props: true,
                },
                {
                    path: 'students/:studentId/update',
                    name: 'updateStudent',
                    component: () => import('@/views/modules/school/profiles/student/StudentUpdateView.vue'),
                    props: true,
                },
                {
                    path: 'authorization',
                    name: 'schoolAuthorization',
                    props: true,
                    component: () => import('@/views/modules/school/authorization/SchoolAuthorizationView.vue'),
                }
            ],
        },
    ]
};